import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { SECURITY_FEATURE_GROUP } from './group';

export const SECURITY_FEATURES = {
  READ: {
    guid: '6b7ba2f6-69f8-4635-b8bc-5224faa6e00d',
    name: 'security:read',
    description: 'View the organization security policy',
    action: 'read',
    product: 'account',
    parentGuid: SECURITY_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: 'cfa92500-1858-49f8-b44d-fcd53dcb8ace',
    name: 'security:update',
    description: 'Edit the organization security policy',
    action: 'update',
    product: 'account',
    parentGuid: SECURITY_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { SECURITY_FEATURE_GROUP } from './group';

export const SECURITY_MODULE: FeatureModule = {
  product: 'account',
  groups: [SECURITY_FEATURE_GROUP],
  features: featureList(SECURITY_FEATURES),
};
